export const GET_CART_SUCCESS = "HOME/GET_CART_SUCCESS";
export const ADD_CART_SUCCESS = "HOME/ADD_CART_SUCCESS";
export const CHANGE_CART_SUCCESS = "HOME/CHANGE_CART_SUCCESS";
export const DELETE_ITEM_SUCCESS = "HOME/DELETE_ITEM_SUCCESS";
export const DELETE_CART_SUCCESS = "HOME/DELETE_CART_SUCCESS"

/**
 * get cart success
 * @param {Array} cart 
 */
export function getCartSuccess(cart, price) {
  return {
    type: GET_CART_SUCCESS,
    payload: {
      cart,
      price
    }
  };
};

/**
 * add product to cart success
 * @param {Array} cart 
 */
export function addToCartSuccess(cart, price) {
  return {
    type: ADD_CART_SUCCESS,
    payload: {
      cart,
      price
    }
  }
}

export function changeCountItemSuccess(cart, price) {
  return {
    type: CHANGE_CART_SUCCESS,
    payload: {
      cart,
      price
    }
  }
}

export function deleteItemSuccess(cart, price) {
  return {
    type: DELETE_ITEM_SUCCESS,
    payload: {
      cart,
      price
    }
  }
}

export function deleteCartSuccess() {
  return {
    type: DELETE_CART_SUCCESS,
    payload: {

    }
  }
}

/**
 * get cart
 * @param {Object} params 
 */
export function getCart(params) {
  return (dispatch, getState, ecommerce) => {
    return new Promise ((resolve, reject) => {
      ecommerce.Cart.getCart(params)
        .then(r => {
          const cart = r.data.cart;
          const price = r.data.price;

          dispatch(getCartSuccess(cart, price));

          resolve(cart);
        })
        .catch(e => {
          reject(e);
        })
    });
  };
};

/**
 * add to cart
 * @param {Object} product 
 * @param {Object} params 
 */
export function addToCart(product, params) {
  return (dispatch, getState, ecommerce) => {
    return new Promise ((resolve, reject) => {
      ecommerce.Cart.addToCart(product, params)
        .then(r => {
          const cart = r.data.cart;
          const price = r.data.price;

          dispatch(addToCartSuccess(cart, price));

          resolve(cart);
        })
        .catch(e => {
          reject(e);
        })
    });
  };
};

export function changeCountItem(id, product, params) {
  return (dispatch, getState, ecommerce) => {
    return new Promise ((resolve, reject) => {
      ecommerce.Cart.changeCountItem(id, product, params)
        .then(r => {
          const cart = r.data.cart;
          const price = r.data.price;

          dispatch(changeCountItemSuccess(cart, price));

          resolve(cart);
        })
        .catch(e => {
          reject(e);
        })
    });
  };
};

export function deleteItem(id, params) {
  return (dispatch, getState, ecommerce) => {
    return new Promise ((resolve, reject) => {
      ecommerce.Cart.deleteItem(id, params)
        .then(r => {
          const cart = r.data.cart;
          const price = r.data.price;

          dispatch(deleteItemSuccess(cart, price));

          resolve(cart);
        })
        .catch(e => {
          reject(e);
        })
    });
  };
};

export function deleteAllCartItem() {
  return (dispatch, getState, ecommerce) => {
    return new Promise ((resolve, reject) => {
      ecommerce.Cart.deleteCart()
        .then(r => {
          dispatch(deleteCartSuccess());

          resolve(r);
        })
        .catch(e => {
          reject(e);
        })
    });
  };
}

// function handleChangeCart(state, paylod) {
//   return state.cart.map(c => {
//     if(c.id === paylod.cart.id) {
//       return paylod.cart
//     }

//     return c
//   })
// }

export default function reducer(
  state = {
    cart: [],
    price: null
  },
  { type, payload }
) {
  switch (type) {
    case GET_CART_SUCCESS:
      return Object.assign({}, state, {
        cart: [...payload.cart],
        price: payload.price,
      })

    case ADD_CART_SUCCESS:
      return Object.assign({}, state, {
        cart: [...payload.cart],
        price: payload.price,
        // cart: [payload.cart, ...state.cart]
      })

    case CHANGE_CART_SUCCESS:
      return Object.assign({}, state, {
        // cart: handleChangeCart(state, payload)
        cart: [...payload.cart],
        price: payload.price,
      })

    case DELETE_ITEM_SUCCESS:
      return Object.assign({}, state, {
        // cart: payload.cart
        cart: [...payload.cart],
        price: payload.price,
      })

    case DELETE_CART_SUCCESS:
      return Object.assign({}, state, {
        cart: [],
        price: null
      })

    default: 
      return state
  }
}